import { render } from "./ListaIndicadoresComponent.vue?vue&type=template&id=29d539f7"
import script from "./ListaIndicadoresComponent.vue?vue&type=script&lang=js"
export * from "./ListaIndicadoresComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__